<template>
  <DashboardPage>
    <AuctionCalendarForm :id="route.params.id" />
  </DashboardPage>
</template>
    
<script setup>
import { useRoute } from 'vue-router';

import DashboardPage from '@/components/DashboardPage.vue'

import AuctionCalendarForm from './components/AuctionCalendarForm.vue';
  
const route = useRoute()
  
</script>